import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'withdrawalAccount',
  namespaced: true,
  actions: {
    async updateWithdrawalAccount({ rootState }, account) {
      const { data } = await defaultApi.putWithdrawalAccount(rootState.auth.info.uuid, account)
      return data
    },
    async confirmVerifyWord({ rootState }, verifyWord) {
      const { data } = await defaultApi.postWithdrawalAccountVerifyWithdrawalAccount(
        rootState.auth.info.uuid,
        verifyWord,
      )
      return data
    },
  },
}
